<template>
  <div>
    <div class="sidebar">
      <slot />
    </div>
  </div>

</template>

<script>
export default {
  name: "Sidebar",

  // props: {
  //   transformToPopup: {
  //     type: Boolean,
  //     default: false,
  //   },

  //   propsHandleClickClose: {
  //     type: Function,
  //     default: null,
  //   },
  // },

  data() {
    return {
      banners: null,
      polls: null,
      filters: null,
    };
  },

  mounted() {
    this.filters = this.$store.state.Global.filters;
  },

  methods: {
    handleClickClose(value) {
      if (this.propsHandleClickClose) this.propsHandleClickClose(value);
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.sidebar {
  width: 100%;
  padding-left: 8rem;
  @include below($lg) {
    padding-left: 0;
  }

  .search {
    width: 100%;
    margin-bottom: 2.8rem;
  }

  &_popup {
    @include below($lg) {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 20;
      width: 100%;
      height: 100%;
      background: #ffffff;
      padding: 8rem 2.5rem 2.5rem;
      overflow-x: hidden;
      overflow-y: auto;

      &.show {
        display: block;
      }
    }
  }

  &__close {
    display: none;
    position: absolute;
    top: 3rem;
    right: 2.5rem;
    background: none;
    box-shadow: none;
    border: none;

    @include below($lg) {
      display: block;
    }
  }

  &__banners {
    &-item {
      margin-bottom: 2rem;
    }
  }
}
</style>
